export const interviewCategories = [
  {
    title: "Engineering Design Process",
    description: "(All Awards)",
    category: "engineering",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team shows evidence of independent inquiry from the beginning stages of their design process. This includes brainstorming, testing, and exploring alternative solutions.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team shows evidence of independent inquiry for some elements of their design process.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team shows little to no evidence of independent inquiry in their design process.",
      },
    ],
  },
  {
    title: "Game Strategies",
    description: "(Design, Innovate, Create, Amaze)",
    category: "game",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team can fully explain their entire game strategy including game analysis.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team can explain their current strategy with limited evidence of game analysis.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team did not explain game strategy/strategy is not student-directed.",
      },
    ],
  },
  {
    title: "Robot Design",
    description: "(Design, Innovate, Build, Create, Amaze)",
    category: "robot_design",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team can fully explain the evolution of their robot design to the current design.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team can provide a limited description of why the current robot design was chosen, but shows limited evolution.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team did not explain robot design, or design is not student-directed.",
      },
    ],
  },
  {
    title: "Robot Build",
    description: "(Innovate, Build, Create, Amaze)",
    category: "robot_build",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team can fully explain their robot construction. Ownership of the robot build is evident.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team can describe why the current robot design was chosen, but with limited explanation.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team did not explain robot build, or build is not student-directed.",
      },
    ],
  },
  {
    title: "Robot Programming",
    description: "(Design, Innovate, Think, Amaze)",
    category: "robot_programming",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message: "Team can fully explain the evolution of their programming.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team can describe how the current programs work, but with limited evolution.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team did not explain programming, or programming is not student-directed.",
      },
    ],
  },
  {
    title: "Creativity / Originality",
    description: "(Innovate, Create)",
    category: "creativity",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team can describe creative aspect(s) of their robot with clarity and detail.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team can describe a creative solution but the answer lacks detail.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team has difficulty describing a creative solution or gives minimal response.",
      },
    ],
  },
  {
    title: "Team and Project Management",
    description: "(All Awards)",
    category: "team_management",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team can explain how team progress was tracked against an overall project timeline. Team can explain management of material and personnel resources.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team can explain how team progress was monitored, and some degree of management of material and personnel resources.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Team cannot explain how team progress was monitored or how resources were managed.",
      },
    ],
  },
  {
    title: "Teamwork, Communication, Professionalism",
    description: "(All Awards)",
    category: "teamwork",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Most or all team members contribute to explanations of the design process, game strategy, and other work done by the team.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Some team members contribute to explanations of the design process, game strategy, and other work done by the team.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message:
          "Few team members contribute to explanations of the design process, game strategy, and other work done by the team.",
      },
    ],
  },
  {
    title: "Respect, Courtesy, Positivity",
    description: "(All Awards)",
    category: "respect",
    options: [
      {
        level: "expert",
        label: "Expert (4,5)",
        message:
          "Team consistently interacts respectfully, courteously, and positively in their interview.",
      },
      {
        level: "proficient",
        label: "Proficient (2,3)",
        message:
          "Team interactions show signs of respect and courtesy, but there is room for improvement.",
      },
      {
        level: "emerging",
        label: "Emerging (0,1)",
        message: "Team interactions lack respectful and courteous behavior.",
      },
    ],
  },
];
